import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, addUser, setUser } from '../../actions/user';
import { addNewCategory, addNewDepartment } from '../../actions/department';
import { addNewActivity, updateActivity } from '../../actions/activity';
import { addDeliverable, updateDeliverableItem } from '../../actions/deliverable';
import Search from '../Search/';
import { FormateDate, searchUsers, searchDependencies, stringToSlug, snapshotToArray } from '../../helpers';
import Validation, { StatusValidation, DeliverableValidation } from '../../helpers/validation';
import EmailService from '../../helpers/email';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { fetchDependencies } from '../../actions/dependency';
import Description from './description';
import DeleteActivity from "../DeleteActivity";
import Status from './status';

const TabOuter = styled.div`
						border:solid 1px #F5DADA;
						.react-calendar__tile--active {
							background: #F5DADA!important;
							color: white!important;
							border-radius: 50%;
							&:hover{
								background: #F5DADA;
							}
						}
						.react-calendar__month-view__weekdays{
							display:none!important;
						}
						.react-calendar__navigation {
							margin-bottom: 0px;
						}
						.react-calendar__tile {
							max-width: 100%;
							text-align: center;
							padding: 0.5em 0.5em;
						}
						.react-calendar__month-view{
							width:80%;
							margin:auto;
						}

`;

const SearchSuggestions = styled.div`
                        background:#E8E8E8;
                        border: 1px solid #ced4da;
                        border-top:0px;
						
						.search-selected{
                          	background:#fff;
                          	border-left: solid 1px #F5DADA;
							
							  ul{
								li{
									&:hover{
										color:#fff;
										background: #0184FE
									}
								}
							}
                        }
                        ul{
							list-style-type:none;
							margin:0px;
							padding:0px;

							li{
								padding: 5px 15px;
							}
                        }
`;

const SelectCategory = styled.div`
						#createCat{
							width:85%;
							float:left;
							margin-right:5px;
						}
`

const SelectDepartment = styled.div`
						#createDept{
							width:85%;
							float:left;
							margin-right:5px;
						}
`

const _getActivityObject = () => {

	let actObj = {};

	actObj.name = '';
	actObj.status = 'scheduled';
	actObj.description = '';
	actObj.users = [];
	actObj.dependencies = [];
	actObj.start = '';
	actObj.finish = '';
	actObj.last_updated = new Date();
	actObj.dept = '';
	actObj.category = '';
	actObj.objective = '';

	return actObj;
}

const _getNewCategory = () => {
	let catObj = {};
	catObj.name = '';
	catObj.slug = '';

	return catObj;
}

const _getNewDepartment = () => {
	let deptObj = {};
	deptObj.name = '';
	deptObj.slug = '';

	return deptObj;
}


const AddActivity = (props) => {
	const [activity, setActivity] = useState(props.item ? props.item : _getActivityObject());
	const [errors, setErrors] = useState([]);
	const [newCat, setNewCat] = useState(_getNewCategory());
	const [newDept, setNewDept] = useState(_getNewDepartment());
	const [showNew, setShowNew] = useState(false);
	const [showNewDept, setShowNewDept] = useState(false);
	const [showDelete, setShowDelete] = useState(false);

	const users = useSelector(state => state.users);
	const currentUser = useSelector(state => state.currentUser);

	//Uncomment this if you wish to test admin permissions on a development enviroment
	// if (!currentUser.role) {
	// 	currentUser.role = 'admin';
	// }
	const activities = useSelector(state => state.activities);
	const departments = useSelector(state => state.departments);
	const dependencies = useSelector(state => state.dependencies);
	const objectives = useSelector(state => state.objectives);
	const deliverables = useSelector(state => state.deliverables);

	const handleDelete = () => setShowDelete(false);

	let index = activity.dept ? (departments.findIndex(x => x.slug == activity.dept)
		!== -1 ? departments.findIndex(x => x.slug == activity.dept) : 0) : 0;

	const dept = departments[index];

	const [showEdit, setShowEdit] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		if (props.item) {
			setActivity(props.item);
		}
	}, [activities]);

	useEffect(() => {
		dispatch(fetchDependencies());
	}, []);

	useEffect(() => {
		if (!props.item) return;
		if (departments && departments.length > 0) {
			let index = activity.dept ? (departments.findIndex(x => x.slug == activity.dept)
				!== -1 ? departments.findIndex(x => x.slug == activity.dept) : 0) : 0;

			setActivity({
				...activity,
				dept: departments[index].slug,
				category: (props.item && props.item.category ? props.item.category : Object.values(departments[index].categories)[0].slug)
			});

		}

	}, [departments]);

	useEffect(() => {
		if (dept && dept.categories && Object.values(dept.categories).length > 1) {
			if (Object.values(dept.categories).findIndex(x => x.slug === activity.category) > -1) return;

			setActivity({
				...activity,
				category: ''
			});
		}
	}, [dept]);

	const updateUsers = (users) => {

		setActivity({
			...activity,
			users: users
		});

	}
	const updateDependencies = (dependencies) => {
		setActivity({
			...activity,
			dependencies: dependencies
		});
	}

	const setStart = (date) => {
		setActivity({
			...activity,
			start: FormateDate(date)
		});
	}

	const updateObjective = (event) => {
		setActivity({
			...activity,
			objective: event.target.value
		});
	}

	const setFinish = (date) => {
		setActivity({
			...activity,
			finish: FormateDate(date)
		});
	}

	const getNewDependencies = () => {
		let _newDependencies = [];

		activity.dependencies.map((value, index) => {
			let parent = dependencies.findIndex(x => x.parent == value.key);
			let _object;

			if (parent === -1) {
				let _parent = activities[activities.findIndex(x => x.key === value.key)];
				_object = {
					status: _parent.status, finish: _parent.finish,
					parent: value.key, key: value.key
				};

			} else {
				_object = dependencies[parent];
			}

			_newDependencies.push(_object);
		});

		return _newDependencies;
	}

	const createActivity = () => {

		if (props.deliverable) {
			let _validation = DeliverableValidation(activity, objectives);

			if (_validation.length > 0) {

				setErrors(_validation);

				setTimeout(function () {
					setErrors([]);
				}, 5000);
				return;
			}
			dispatch(addDeliverable(activity));
		} else {
			if (Validation(activity, deliverables).length > 0) {
				setErrors(Validation(activity, deliverables));

				setTimeout(function () {
					setErrors([]);
				}, 5000);
				return;
			}
			let _newDependencies = getNewDependencies();

			activity.last_updated = new Date().toString();
			dispatch(addNewActivity(activity, _newDependencies));

			let email = new EmailService();
			email.sendEmail(activity);
		}

		setActivity(_getActivityObject());
		props.onHide();
	}

	const _updateActivity = () => {
		if (props.deliverable) {

			let _validation = DeliverableValidation(activity, objectives);

			if (_validation.length > 0) {

				setErrors(_validation);

				setTimeout(function () {
					setErrors([]);
				}, 5000);
				return;
			}
			dispatch(updateDeliverableItem(activity));
			props.onHide();
			setShowEdit(false);

			return;
		}
		let _validation = Validation(activity, deliverables);

		if (activity.status === 'completed') {
			if (!StatusValidation(activity, dependencies)) {
				_validation.unshift("Dependencies must be completed to mark as complete");
			}
		}

		if (_validation.length > 0) {

			setErrors(_validation);

			setTimeout(function () {
				setErrors([]);
			}, 5000);
			return;
		}

		let updates = [];
		//Update existing dependencies
		dependencies.map((value, index) => {
			let _index = value.children.findIndex(x => x === activity.key);
			if (_index !== -1) {
				//If in dependencies but not in current activity, update
				if (activity.dependencies.findIndex(x => x.key === value.parent) === -1) {

					let _children = value.children;
					_children.splice(_index, 1);
					let _dept = { ...value };
					_dept.children = _children;
					updates.push(_dept);
				}// } else {
				// 	//Add new child to existing dependency
				// 	let _children = value.children;
				// 	_children.push(activity.key);
				// 	let _dept = {...value};
				// 	_dept.children = _children;
				// 	updates.push(_dept);
				// }
			}

		});
		// Check if other activities are dependant on activity
		if ((props.item.status !== activity.status) || (props.item.finish !== activity.finish)) {
			let dependants = dependencies.filter(x => x.parent === activity.key);

			dependants.map((value, index) => {
				let _dept = { ...value };
				_dept.finish = activity.finish;
				_dept.status = activity.status;

				updates.push(_dept);
			});
		}
		//check if activity dependencies exist in dependencies, if not add
		let _newDependencies = [];

		activity.dependencies.map((value, index) => {
			let parent = dependencies.findIndex(x => x.parent == value.key);
			let _object;
			if (parent === -1) {
				_object = {
					finish: activities[activities.findIndex(x => x.key === value.key)].finish,
					parent: value.key, key: value.key
				};

				_newDependencies.push(_object);
			} else {
				let _children = dependencies[parent].children;
				if (_children.findIndex(x => x === activity.key) === -1) {
					_children.push(activity.key);
					let _dept = { ...dependencies[parent] };
					_dept.children = _children;
					updates.push(_dept);
				}
			}

		});
		activity.last_updated = new Date().toString();
		dispatch(updateActivity(activity, updates, _newDependencies));

		let email = new EmailService();
		email.sendEmail(activity);
		props.onHide();
		setShowEdit(false);

	}

	const updateTitle = (event) => {
		setActivity({
			...activity,
			name: event.target.value
		});
	}

	const updateDescription = (event) => {
		setActivity({
			...activity,
			description: event.target.value
		});
	}

	const updateStatus = (value) => {

		setActivity({
			...activity,
			status: value
		});
	}

	const updateDepartment = (event) => {
		if (event.target.value === 'new-dept') {
			setShowNewDept(true);
			setActivity({
				...activity,
				dept: ''
			});
		} else {

			setActivity({
				...activity,
				dept: event.target.value,

			});

		}
		// setActivity({
		// 	...activity,
		// 	category: ''

		// });
	}

	const updateDeliverable = (event) => {

		setActivity({
			...activity,
			deliverable: event.target.value,

		});

	}


	const addCategory = () => {
		dispatch(addNewCategory(dept.slug, newCat));

		setTimeout(() => {
			let element = document.getElementById('cat1');
			element.value = newCat.slug;

			setActivity({
				...activity,
				category: newCat.slug
			});

			setShowNew(false);

		}, 1500);

		//setNewCat(_getNewCategory());
	}

	const addDepartment = () => {
		if (!newDept.categories) {
			newDept.categories = 'null';
		}
		dispatch(addNewDepartment(newDept));

		setTimeout(() => {
			let element = document.getElementById('dept1');
			element.value = newDept.slug;

			setActivity({
				...activity,
				dept: newDept.slug
			});

			setShowNewDept(false);

		}, 1500);

		//setNewCat(_getNewCategory());
	}

	const setCategory = (event) => {
		if (event.target.value === 'new-cat') {
			setShowNew(true);
			setActivity({
				...activity,
				category: ''
			});
		} else {
			setShowNew(false);
			setActivity({
				...activity,
				category: event.target.value
			});
		}
	}

	const getCurrentDate = () => {
		let date = new Date();

		let day = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();

		return `${year}-${month}-${day}`;
	}

	const showEditMode = () => {
		setShowEdit(true);
	}

	const handleDeleteShow = function (event) {
		event.preventDefault();
		setShowDelete(true);
	};

	const deleteItem = function (event) {
		event.preventDefault();
		setShowDelete(true);
	};

	const hideParent = function (event) {
		props.onHide();
	}

	return (

		<Modal show={props.show} onHide={props.onHide} id="activity-modal">
			{(props.item && !showEdit) ?

				<Description item={props.item} departments={departments} edit={showEditMode} currentUser={currentUser} dependencies={dependencies} deliverable={props.deliverable ? props.deliverable : false} />

				:
				<React.Fragment>
					<Modal.Header closeButton>
						{props.deliverable ?
							<Modal.Title>{props.item ? 'Edit Deliverable' : 'Post Deliverable'}</Modal.Title>
							:
							<Modal.Title>{props.item ? 'Edit Activity' : 'Post Activity'}</Modal.Title>
						}
					</Modal.Header>
					<Modal.Body>
						<div className="row">
							<div className="col-sm-12 col-lg-7">
								<form>
									<div className="form-group">
										<input type="text" className="form-control" id="activityTitle" value={activity.name} placeholder={props.deliverable ? 'Deliverable title' : 'Activity title'}
											onChange={updateTitle} autoComplete="off" />
									</div>
									<div className="form-group">
										<small id="description" className="form-text text-muted">Describe your activity in more detail</small>
										<textarea className="form-control" id="activityDescription" rows="5" onKeyUp={updateDescription}
											value={activity.description} onChange={updateDescription}></textarea>
										<small id="descriptionWarning" className="form-text activity-warning">Information shared here will be available to all Arq employees</small>
									</div>
									<Search title="Tag Owner(s)" id="owners" data={users} onSelect={updateUsers} model={searchUsers}
										selected={props.item && props.item.users ? props.item.users : []} />
									{!props.deliverable ?
										<Search title="Dependencies" id="dependency" data={activities} onSelect={updateDependencies} model={searchDependencies}
											selected={props.item && props.item.dependencies ? props.item.dependencies : []}
											warning="Select other activities that MUST be completed first before this activity can signed off" />
										: ''}
								</form>
							</div>
							<div className="col-sm-12 col-lg-5">
								<div className="row">
									<div className="col-12">
										<TabOuter>
											<Tabs id="calendar-tabs">
												<Tab eventKey="start-date" title="Start date">
													<Calendar onChange={setStart} value={props.item && props.item.start ? new Date(props.item.start) : new Date(getCurrentDate())} />
												</Tab>
												<Tab eventKey="due-date" title="Due date">
													<Calendar onChange={setFinish} value={props.item && props.item.finish ? new Date(props.item.finish) : new Date(getCurrentDate())} />
												</Tab>
											</Tabs>
										</TabOuter>
									</div>
								</div>
								{props.deliverable ?
									<div className="row">
										<div className="col-12 pt-3">
											<div className="form-group">
												<label htmlFor="objective1">Select Objective:</label>
												<select className="form-control" id="objective1" onChange={updateObjective} defaultValue={activity.objective}>
													<option value=''></option>
													{objectives.map((objective, index) => (
														<option value={objective.key} key={index}>{objective.name}</option>
													)
													)}
												</select>
											</div>
										</div>
									</div>
									: ''}
								<SelectDepartment>
									<div className="row">
										<div className="col-12 pt-3">
											<div className="form-group">
												<label htmlFor="dept1">Select Department:</label>
												<select className="form-control" id="dept1" onChange={updateDepartment} defaultValue={activity.dept}>
													<option value=''></option>
													{departments.map((department, index) => (
														<option value={department.key} key={index}>{department.name}</option>
													)
													)}
													{currentUser.role && currentUser.role === 'admin' ?
														<option value='new-dept'>New Department</option> :
														''}
												</select>
											</div>
											{showNewDept ?
												<div className="row">
													<div className="col-12">
														<div className="form-group">
															<input type="text" className="form-control" id="createDept" value={newDept.name}
																onChange={event => setNewDept({ name: event.target.value, slug: stringToSlug(event.target.value) })} placeholder="Add Department" autoComplete="off" />
															<button className="btn btn-primary" type="submit" onClick={addDepartment}><FontAwesomeIcon icon={faPlus} /></button>
														</div>
													</div>
												</div> : ''
											}
										</div>
									</div>
									{!props.deliverable ?
										<div className="row">
											<div className="col-12 pt-3">
												<div className="form-group">
													<label htmlFor="deliverable1">Select Deliverable:</label>
													<select className="form-control" id="deliverable1" onChange={updateDeliverable} defaultValue={activity.deliverable}>
														<option value=''></option>
														{deliverables.filter(deliverable => deliverable.dept === activity.dept).map((deliverable, index) => (
															<option value={deliverable.key} key={index}>{deliverable.name}</option>
														)
														)}
													</select>
												</div>
												{showNewDept ?
													<div className="row">
														<div className="col-12">
															<div className="form-group">
																<input type="text" className="form-control" id="createDept" value={newDept.name}
																	onChange={event => setNewDept({ name: event.target.value, slug: stringToSlug(event.target.value) })} placeholder="Add Department" autoComplete="off" />
																<button className="btn btn-primary" type="submit" onClick={addDepartment}><FontAwesomeIcon icon={faPlus} /></button>
															</div>
														</div>
													</div> : ''
												}
											</div>
										</div> : ''}
								</SelectDepartment>
								{!props.deliverable ?
									<SelectCategory>
										<div className="row">
											<div className="col-12">
												<div className="form-group mb-1">
													<label htmlFor="cat1">Select Work Stream:</label>
													<select className="form-control" id="cat1" onChange={setCategory} defaultValue={activity.category}>

														<option value=''></option>
														{dept && dept.categories && dept.categories !== 'null' ? Object.values(dept.categories).map((category, index) => (
															<option value={category.slug} key={index}>{category.name}</option>
														)

														) : ''}
														{currentUser.role && currentUser.role === 'admin' ?
															<option value='new-cat'>New category</option>
															: ''}
													</select>
												</div>
												{showNew || (dept && !dept.categories) ?
													<div className="row">
														<div className="col-12">
															<div className="form-group">
																<input type="text" className="form-control" id="createCat" value={newCat.name}
																	onChange={event => setNewCat({ name: event.target.value, slug: stringToSlug(event.target.value) })} placeholder="Add category" autoComplete="off" />
																<button className="btn btn-primary" type="submit" onClick={addCategory}><FontAwesomeIcon icon={faPlus} /></button>
															</div>
														</div>
													</div> : ''
												}
											</div>
										</div>
									</SelectCategory>
									: ''}

								{props.item && (currentUser.role && currentUser.role === 'admin') ?
									<Status updateStatus={updateStatus} status={activity.status} item={props.item} />
									: ''}
							</div>
						</div>
						<div className="row">
							<div className="col-12">

								{errors && errors.length > 0 ?
									<div className="alert alert-danger" role="alert">
										<ul>
											{errors.map((value, index) => (
												<li key={index}>{value}</li>
											)
											)}
										</ul>
									</div>
									: ''
								}
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>

						<Button variant="primary" onClick={props.item ? _updateActivity : createActivity}>
							{props.item ? 'Update' : 'Save'}
						</Button>
						{props.item ?
							<Button variant="btn btn-secondary" onClick={handleDeleteShow}>
								Delete
						    </Button>
							: ''}


					</Modal.Footer>
					{props.item ?
						<DeleteActivity show={showDelete} onHide={handleDelete} item={props.item} deleteItem={deleteItem} hideParent={hideParent} deliverable={props.deliverable} />
						: ''}
				</React.Fragment>
			}

		</Modal>
	);
}

export default AddActivity;
